import { CONFIGURATION_APIS, INVENTORY_MODULE } from "@/api_framework/api_config";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";

import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { setWareHouseList } from "@/app_redux/reducers/slices/auth/configuration_slice";
import { IWarehouseListResponse } from "@/api_framework/api_modals/Configuration";

AxiosCurlirize(axios, () => {});
export const useWareHouseSearchAPI = () => {
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const configuration = useConfiguration();

  const execute = useCallback(
    async (warehouse: string) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        await axios
          .get(`${CONFIGURATION_APIS?.WAREHOUSE_API?.baseURL}?clinic_name=${warehouse}`, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IWarehouseListResponse>) => {
            if (res.data.status === true) {
              dispatch(setWareHouseList({ data: res.data.data }));
            } else {
              dispatch(setWareHouseList({ data: [] }));
            }
          })
          .catch((e: AxiosError) => {
            dispatch(setWareHouseList({ data: [] }));
            sendCurl(e.config["curlCommand"]);
            if (e.code === "ERR_BAD_REQUEST") {
              //   toast.error("Error while fetching List details");
            }
            if (e.status === 400) {
              //   toast("Product records not found");
            }

            if (e.response.status === 500) {
              toast.error("Server error 500");
            }
          });
      } catch (e: any) {
        toast.error("Server Error: " + e.message);
        dispatch(setWareHouseList({ data: [] }));
      }
    },
    [dispatch],
  );
  return { execute };
};
